import IMoney from '../../model/prices/IMoney';
import useMoney from '../prices/useMoney';
import { usePersistedCurrencyPreference } from './usePersistedCurrencyPreference';

const useSelectedCurrencyDiscountPrice = (prices: IMoney[]) => {
  const { primaryPrice, secondaryPrice } = useMoney(prices);
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();

  return { selectedCurrencyDiscountPrice: isSecondaryCurrencyDisplay ? secondaryPrice?.amount : primaryPrice?.amount };
};

export default useSelectedCurrencyDiscountPrice;
